module.exports = __webpack_public_path__ + "static/image2-351557823ca27742ab703d56135d336a.png";